
const moneyMixin = {
    methods: {
        formatMoney (amount, decimalCount = 2, decimal = '.', thousands = ',') {
            try {
              decimalCount = Math.abs(decimalCount)
              decimalCount = isNaN(decimalCount) ? 2 : decimalCount

              const negativeSign = amount < 0 ? '-' : ''

              const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
              const j = (i.length > 3) ? i.length % 3 : 0
              return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
            } catch (e) {
            }
        },
    },
}

const timeFormatMixin = {
  methods: {
    standardTime (time) {
      let ret = null
      if (time) {
        const [mHr, min] = time.split(':')
        const sHr = `${mHr % (12 + (mHr === 12))}`
        ret = `${sHr.padStart(2, '0')}:${min} ${mHr > 11 ? 'PM' : 'AM'}`
      }
      return ret
    },
  },
}

const dateFormatMixin = {
  methods: {
    dateFormat (d) {
      const date = new Date(d)
      const year = date.getFullYear()
      const month = (`${date.getMonth() + 1}`).padStart(2, '0')
      const day = (`${date.getDate()}`).padStart(2, '0')
      return `${month}/${day}/${year}`
    },
    dateFormatSql (d) {
      const date = new Date(d)
      const year = date.getFullYear()
      const month = (`${date.getMonth() + 1}`).padStart(2, '0')
      const day = (`${date.getDate()}`).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
  },
}

export {
    timeFormatMixin,
    moneyMixin,
    dateFormatMixin,
}
